import { Link } from "react-router-dom";
import { Stethoscope, ShieldAlert } from "lucide-react";

export const Footer = () => (
  <footer className="mt-16 border-t border-slate-200 bg-white">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="flex items-center gap-2.5 mb-4">
        <span className="grid place-items-center w-9 h-9 rounded-lg bg-teal-600 text-white">
          <Stethoscope className="w-5 h-5" />
        </span>
        <span className="font-heading font-extrabold text-lg text-slate-900">
          AskMyDoctor <span className="text-teal-600">AI</span>
        </span>
      </div>

      <div
        className="bg-amber-50 border-2 border-amber-300 text-amber-950 rounded-xl p-4 flex items-start gap-3 mb-8"
        data-testid="footer-disclaimer"
      >
        <ShieldAlert className="w-6 h-6 shrink-0 mt-0.5 text-amber-700" />
        <p className="text-base leading-relaxed">
          <strong>Medical disclaimer:</strong> AskMyDoctor AI provides general
          medical information and education. It does not diagnose medical
          conditions or replace care from a physician or other qualified
          healthcare professional. Information is drawn from public U.S.
          government medical sources and may not fit your personal situation.
          If you may be experiencing a medical emergency, call 911.
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-base">
        <Link to="/" className="text-slate-600 hover:text-teal-700 font-medium">Home</Link>
        <Link to="/library" className="text-slate-600 hover:text-teal-700 font-medium">Health Library</Link>
        <Link to="/privacy" className="text-slate-600 hover:text-teal-700 font-medium">Privacy Policy</Link>
        <Link to="/terms" className="text-slate-600 hover:text-teal-700 font-medium">Terms of Use</Link>
        <Link to="/disclaimer" className="text-slate-600 hover:text-teal-700 font-medium">Full Disclaimer</Link>
        <Link to="/admin" className="text-slate-600 hover:text-teal-700 font-medium">Dashboard</Link>
      </div>

      <p className="mt-8 text-sm text-slate-500 leading-relaxed">
        Medical answers are independent and are never influenced by advertisers.
        Sources include MedlinePlus (National Library of Medicine), the U.S. Food
        and Drug Administration (openFDA), and RxNorm.
        © {new Date().getFullYear()} AskMyDoctor AI.
      </p>
    </div>
  </footer>
);
